var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "264px",
    height: "280px",
    viewBox: "0 0 264 280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with getavataaars.com")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "react-path-1",
    cx: 120,
    cy: 120,
    r: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z",
    id: "react-path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z",
    id: "react-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-825.000000, -1100.000000)",
    id: "Avataaar/Circle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(825.000000, 1100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(12.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Circle-Background",
    fill: "#E6E6E6",
    xlinkHref: "#react-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Blue-01",
    mask: "url(#react-mask-4)",
    fill: "#FFD15C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#react-mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(32.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D0C6AC",
    xlinkHref: "#react-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFD-03-Brown",
    mask: "url(#react-mask-6)",
    fill: "#614335"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z",
    id: "Neck-Shadow",
    fillOpacity: 0.100000001,
    fill: "#000000",
    mask: "url(#react-mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clothing/Hoodie",
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M108,13.0708856 C90.0813006,15.075938 76.2798424,20.5518341 76.004203,34.6449676 C50.1464329,45.5680933 32,71.1646257 32,100.999485 L32,100.999485 L32,110 L232,110 L232,100.999485 C232,71.1646257 213.853567,45.5680933 187.995797,34.6449832 C187.720158,20.5518341 173.918699,15.075938 156,13.0708856 L156,32 L156,32 C156,45.254834 145.254834,56 132,56 L132,56 C118.745166,56 108,45.254834 108,32 L108,13.0708856 Z",
    id: "react-path-107"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-108",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-107"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Hoodie",
    fill: "#B7C1DB",
    fillRule: "evenodd",
    xlinkHref: "#react-path-107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Gray-01",
    mask: "url(#react-mask-108)",
    fillRule: "evenodd",
    fill: "#262E33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 264,
    height: 110
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102,61.7390531 L102,110 L95,110 L95,58.1502625 C97.2037542,59.4600576 99.5467694,60.6607878 102,61.7390531 Z M169,58.1502625 L169,98.5 C169,100.432997 167.432997,102 165.5,102 C163.567003,102 162,100.432997 162,98.5 L162,61.7390531 C164.453231,60.6607878 166.796246,59.4600576 169,58.1502625 Z",
    id: "Straps",
    fill: "#F4F4F4",
    fillRule: "evenodd",
    mask: "url(#react-mask-108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9601329,12.7243537 C75.9093095,15.5711782 65.5,21.2428847 65.5,32.3076923 C65.5,52.0200095 98.5376807,68 132,68 C165.462319,68 198.5,52.0200095 198.5,32.3076923 C198.5,21.2428847 188.09069,15.5711782 173.039867,12.7243537 C182.124921,16.0744598 188,21.7060546 188,31.0769231 C188,51.4689754 160.178795,68 132,68 C103.821205,68 76,51.4689754 76,31.0769231 C76,21.7060546 81.8750795,16.0744598 90.9601329,12.7243537 Z",
    id: "Shadow",
    fillOpacity: 0.16,
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#react-mask-108)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(76.000000, 82.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth/Smile",
    transform: "translate(2.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.117844,15.1280772 C36.1757121,24.6198025 44.2259873,32 54,32 C63.8042055,32 71.8740075,24.574136 72.8917593,15.0400546 C72.9736685,14.272746 72.1167429,13 71.042767,13 C56.1487536,13 44.7379213,13 37.0868244,13 C36.0066168,13 35.0120058,14.1784435 35.117844,15.1280772 Z",
    id: "react-path-99"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-100",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-99"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mouth",
    fillOpacity: 0.699999988,
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#react-path-99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Teeth",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#react-mask-100)",
    x: 39,
    y: 2,
    width: 31,
    height: 16,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tongue",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#react-mask-100)",
    fill: "#FF4F6D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 11,
    r: 11
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Nose/Default",
    transform: "translate(28.000000, 40.000000)",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8",
    id: "Nose"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes/Default-\\uD83D\\uDE00",
    transform: "translate(0.000000, 8.000000)",
    fillOpacity: 0.599999964
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Eye",
    cx: 30,
    cy: 22,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Eye",
    cx: 82,
    cy: 22,
    r: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow/Natural/Flat-Natural",
    fillOpacity: 0.599999964
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5686071,10.7022978 C33.5865557,11.2384494 28.6553385,11.1338998 23.6562444,11.1010606 C19.8231061,11.0762636 15.91974,10.6892291 12.3246118,12.5091287 C11.6361455,12.8572921 7.8767609,14.9449324 8.00311195,16.0108688 C8.10389896,16.8633498 12.0128479,18.0636592 12.7165939,18.2838164 C16.4280826,19.4452548 19.9241869,18.9282036 23.6870976,18.5703225 C28.3024371,18.1316834 32.9139567,18.1745756 37.5322346,17.8739956 C40.6422336,17.6719334 45.4224171,16.9769469 46.8293214,13.1484895 C47.2530382,11.9954284 46.8152171,9.73353891 46.3074622,8.50642195 C46.1050066,8.01751871 45.5634602,7.84963624 45.1688335,8.14921095 C43.7560524,9.22218432 40.9851444,10.4425994 38.5686071,10.7022978",
    id: "Fill-10",
    transform: "translate(27.500000, 13.500000) rotate(2.000000) translate(-27.500000, -13.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5686071,10.7022978 C90.5865557,11.2384494 85.6553385,11.1338998 80.6562444,11.1010606 C76.8231061,11.0762636 72.91974,10.6892291 69.3246118,12.5091287 C68.6361455,12.8572921 64.8767609,14.9449324 65.003112,16.0108688 C65.103899,16.8633498 69.0128479,18.0636592 69.7165939,18.2838164 C73.4280826,19.4452548 76.9241869,18.9282036 80.6870976,18.5703225 C85.3024371,18.1316834 89.9139567,18.1745756 94.5322346,17.8739956 C97.6422336,17.6719334 102.422417,16.9769469 103.829321,13.1484895 C104.253038,11.9954284 103.815217,9.73353891 103.307462,8.50642195 C103.105007,8.01751871 102.56346,7.84963624 102.168833,8.14921095 C100.756052,9.22218432 97.9851444,10.4425994 95.5686071,10.7022978",
    id: "Fill-10",
    transform: "translate(84.500000, 13.500000) scale(-1, 1) rotate(2.000000) translate(-84.500000, -13.500000) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "react-path-310",
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,64 C1.34685629,65.488448 2.67275588,65.2226722 3,64 C2.53726005,62.445722 6.29594493,35.2480719 16,28 C19.618222,25.4833872 39.0082164,23.2319099 58.3126144,23.245568 C77.4086061,23.2590787 96.4208396,25.5105561 100,28 C109.704055,35.2480719 113.46274,62.445722 113,64 C113.327244,65.2226722 114.653144,65.488448 115,64 C115.719178,53.7019177 115,0.274362825 58,1 C1,1.72563718 0.280821545,53.7019177 1,64 Z",
    id: "react-path-311"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.8%",
    y: "-2.0%",
    width: "101.5%",
    height: "108.0%",
    filterUnits: "objectBoundingBox",
    id: "react-filter-307"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-308",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-310"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Top/Short-Hair/The-Caesar",
    mask: "url(#react-mask-308)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hair",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(75.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-309",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-311"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Caesar",
    fill: "#28354B",
    xlinkHref: "#react-path-311"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFD-03-Brown",
    mask: "url(#react-mask-309)",
    fill: "#2C1B18"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000) ",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 264,
    height: 280
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Top/_Resources/Prescription-02",
    fill: "none",
    transform: "translate(62.000000, 85.000000)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-0.8%",
    y: "-2.4%",
    width: "101.5%",
    height: "109.8%",
    filterUnits: "objectBoundingBox",
    id: "react-filter-312"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Wayfarers",
    filter: "url(#react-filter-312)",
    transform: "translate(6.000000, 7.000000)",
    fill: "#252C2F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,41 L31.2421498,41 C17.3147125,41 9,33.3359286 9,20.5 C9,10.127 10.8170058,0 32.5299306,0 L35.4700694,0 C57.1829942,0 59,10.127 59,20.5 C59,32.5686429 48.7212748,41 34,41 Z M32.3853606,6 C13,6 13,12.8410159 13,21.5015498 C13,28.5719428 16.116254,37 30.9709365,37 L34,37 C46.3649085,37 55,30.6270373 55,21.5015498 C55,12.8410159 55,6 35.6146394,6 L32.3853606,6 Z",
    id: "Left",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,41 L93.2421498,41 C79.3147125,41 71,33.3359286 71,20.5 C71,10.127 72.8170058,0 94.5299306,0 L97.4700694,0 C119.182994,0 121,10.127 121,20.5 C121,32.5686429 110.721275,41 96,41 Z M94.3853606,6 C75,6 75,12.8410159 75,21.5015498 C75,28.5719428 78.1194833,37 92.9709365,37 L96,37 C108.364909,37 117,30.6270373 117,21.5015498 C117,12.8410159 117,6 97.6146394,6 L94.3853606,6 Z",
    id: "Right",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95454545,5.77156439 C3.64590909,5.09629136 11.2095455,0 32.5,0 C50.3513636,0 54.1302273,1.85267217 59.8502273,4.6518809 L60.2689233,4.85850899 C60.6666014,4.99901896 62.7002447,5.68982981 65.0790606,5.76579519 C67.2462948,5.67278567 69.1000195,5.08540191 69.641698,4.89719767 C76.1703915,1.7220864 82.5610971,0 97.5,0 C118.790455,0 126.354091,5.09629136 127.045455,5.77156439 C128.679318,5.77156439 130,7.06150904 130,8.65734659 L130,11.5431288 C130,13.1389663 128.679318,14.428911 127.045455,14.428911 C127.045455,14.428911 120.143997,14.428911 120.143997,17.3146932 C120.143997,20.2004754 118.181818,13.1389663 118.181818,11.5431288 L118.181818,8.73240251 C114.578575,7.35340151 108.128411,4.78617535 97.5,4.78617535 C85.6584651,4.78617535 79.7610984,6.88602813 74.7022935,8.97112368 L74.7588636,9.10752861 L74.7563667,11.0937608 L72.5391666,16.4436339 L69.8004908,15.3608351 C69.5558969,15.2641292 69.0281396,15.090392 68.2963505,14.9099044 C66.256272,14.4067419 64.1589087,14.253569 62.3040836,14.6343084 C61.6235903,14.7739931 60.9922286,14.9836085 60.4128127,15.266732 L57.7704824,16.5578701 L55.1266751,11.3962031 L55.2440909,9.10175705 L55.3248203,8.90683855 C50.9620526,6.87386374 46.9392639,4.78617535 32.5,4.78617535 C21.8721459,4.78617535 15.422131,7.3524397 11.8181818,8.7314671 L11.8181818,11.5431288 C11.8181818,13.1389663 8.86363636,20.2004754 8.86363636,17.3146932 C8.86363636,14.428911 2.95454545,14.428911 2.95454545,14.428911 C1.32363636,14.428911 0,13.1389663 0,11.5431288 L0,8.65734659 C0,7.06150904 1.32363636,5.77156439 2.95454545,5.77156439 Z",
    id: "Stuff",
    fillRule: "nonzero"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar-1.09f66d2157a4760a7fb5d009f6ce19dd.svg";
export { ForwardRef as ReactComponent };